import Head from 'next/head';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { END } from 'redux-saga';
import React from 'react';
// import loadjs from 'loadjs';
import nextI18nextConfig from '~/../next-i18next.config';
import { wrapper } from '~/store';
import defaultPage, {
  defaultPageServerSideContext,
} from '~/../hocs/defaultPage';
import HrefLangs from '~/components/HrefLangs';
import config from '~/config';
import CategoriesPage from '~/containers/CategoriesPage';
import { loadCategories } from '~/containers/CategoriesPage/actions';
import { loadRandomSliderImages } from '~/containers/HomePage/actions';
import Layout from '~/containers/Layout';
import { loadPinterest } from '~/utils/file-helper';

@defaultPage(['page-categories'])
class Categories extends React.Component {
  componentDidMount() {
    loadPinterest();
  }

  render() {
    const { t, lng } = this.props;
    // TODO: Add meta for og, twitter
    return (
      <Layout>
        <Head>
          <HrefLangs pagePath="/categories" lng={lng} />
          <title>
            {t(config.getPrefixContent('title_all_categories_page'))}
          </title>
          <meta
            id="meta-description"
            name="description"
            content={t(
              config.getPrefixContent('meta_description_all_categories_page'),
            )}
          />
          <meta
            id="meta-keywords"
            name="keywords"
            content={t(
              config.getPrefixContent('meta_keywords_all_categories_page'),
            )}
          />
          {lng === 'en' && <meta property="og:locale" content={'en_US'} />}
          {lng !== 'en' && (
            <meta
              property="og:locale"
              content={lng + '_' + lng?.toUpperCase()}
            />
          )}
        </Head>
        <CategoriesPage />
      </Layout>
    );
  }
}

export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async (ctx) => {
    const i18nProps = await serverSideTranslations(
      ctx.locale || process.env.LANGUAGE,
      ['page-categories', 'common'],
      nextI18nextConfig,
    );

    const {
      token,
      profile,
      accountType,
      isAuthenticated,
      currentLanguage,
      clientIp,
      api,
      sessionId,
      ssoToken,
      query,
    } = await defaultPageServerSideContext({
      ...ctx,
      store,
    });

    store.dispatch(
      loadCategories(
        {
          lang: currentLanguage,
        },
        api,
      ),
    );
    store.dispatch(
      loadRandomSliderImages(
        {
          lang: currentLanguage,
        },
        api,
      ),
    );

    // end the saga
    store.dispatch(END);
    await store.sagaTask.toPromise();

    ctx.res.setHeader(
      'Cache-Control',
      'public, s-maxage=30, stale-while-revalidate=30',
    );
    return {
      props: {
        ...i18nProps,
        token,
        profile,
        accountType,
        isAuthenticated,
        currentLanguage,
        sessionId,
        ssoToken,
        query,
      },
    };
  },
);

export default Categories;
